import Route from '@ember/routing/route';

export default class MarketRevenueInsightCurrencyTableRoute extends Route {}
